import { loader } from 'graphql.macro'

export default function jobEmailQuery ({ dataLoaders, queryKey }) {
  const [, id] = queryKey

  const jobEmailSchema = loader('./jobEmailFromInvoice.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(jobEmailSchema, { id })
}
